<div class="container-fluid">
	<p-toast [style]="{marginTop: '80px'}"></p-toast>
	<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
	<div class="mt-2 d-flex justify-content-between align-items-center">
		<div>
			<h2 style="margin: 0;">Owner Statement Reconciliation</h2>
		</div>
		<div>
			<div [formGroup]="form1" class="forms d-block">
				<div>
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex">
							<div class="p-float-label my-2 me-2">
								<p-calendar inputId="monthYear" formControlName="monthYear" [style]="{'width':'200px'}"
									appendTo="body" view="month" dateFormat="mm/yy" [yearRange]="'2000:2030'"
									placeholder="Select Month/Year" [showIcon]="true" icon="pi pi-calendar">
								</p-calendar>
								<label for="monthYear">Month/Year</label>
							</div>
							<div class="btn-group">
								<div class="button-group">
									<button pButton class="btn-addt p-button" (click)="formSearch()" [disabled]="loading">
										<i class="pi pi-search" style="margin-right: 8px;"></i>
										Search
									</button>
								</div>
							</div>
							<div class="btn-group ml-2">
								<div class="button-group">
									<button pButton class="btn-addt p-button" (click)="refreshReport()" [disabled]="loading">
										<i class="pi pi-refresh" style="margin-right: 8px;"></i>
										Refresh
									</button>
								</div>
							</div>
							<div class="btn-group ml-2">
								<div class="button-group">
									<button pButton class="p-button-text" (click)="reloadPage()"
										style="font-size: 80%; padding: 0.643rem 0.75rem !important;">
										Clear Filters
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div>
				<app-import-export importEnabled="false" [dataRetrived]="reconciliationData"
					(exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true">
				</app-import-export>
			</div>
		</div>
	</div>

	<div class="reconciliation-container">
		<p-table 
			#dt2 
			class="reconciliation-table kbmadmintable" 
			[value]="reconciliationData" 
			dataKey="shortTermRentalId" 
			[loading]="loading" 
			styleClass="p-datatable-striped" 
			[style]="{'width': '100%', 'table-layout': 'auto'}"
			[globalFilterFields]="['propertyCode', 'startDate', 'endDate']"
			[resizableColumns]="true" 
			[autoLayout]="true" 
			[responsive]="true"
			[paginator]="true"
			[rows]="100"
			[rowsPerPageOptions]="[100,1500,3000,4500,6000,100000]"
			showCurrentPageReport="true"
			currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
			[totalRecords]="reconciliationData.length"
			showJumpToPageInput="true">

			<ng-template pTemplate="header">
				<tr>
					<th [pSortableColumn]="'propertyCode'" [style]="{'width': 'auto', 'min-width': '120px'}">
						Property
						<p-sortIcon [field]="'propertyCode'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'startDate'" [style]="{'width': 'auto', 'min-width': '100px'}">
						Start Date
						<p-sortIcon [field]="'startDate'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'endDate'" [style]="{'width': 'auto', 'min-width': '100px'}">
						End Date
						<p-sortIcon [field]="'endDate'"></p-sortIcon>
					</th>
					<th colspan="3" class="text-center" style="background-color: #e3f2fd; font-weight: bold;">
						Expense
					</th>
					<th colspan="3" class="text-center" style="background-color: #fff3e0; font-weight: bold;">
						Statement Expense
					</th>
					<th [pSortableColumn]="'discrepancyAmount'" [style]="{'width': 'auto', 'min-width': '100px'}">
						Discrepancy
						<p-sortIcon [field]="'discrepancyAmount'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'expenseMatch'" [style]="{'width': 'auto', 'min-width': '120px'}">
						Match Status
						<p-sortIcon [field]="'expenseMatch'"></p-sortIcon>
					</th>
					<th [style]="{'width': 'auto', 'min-width': '100px'}">Actions</th>
				</tr>
				<tr>
					<th class="propertycode-filter">
						<p-multiSelect 
						   [style]="{'width':'50px','min-width':'200px'}"
							[options]="propertyOptions" 
							appendTo="body"
							optionLabel="propertyCode" 
							optionValue="propertyCode"
							(onChange)="onPropertyFilterChange($event)" 
							placeholder="Select Properties"
							[filter]="true"
							filterBy="propertyCode"
							[style]="{'width':'100%'}">
						</p-multiSelect>
					</th>
					<th>
						<input 
							pInputText 
							type="date" 
							(input)="dt2.filter($any($event.target).value, 'startDate', 'equals')" 
							[style]="{'width':'100%'}">
					</th>
					<th>
						<input 
							pInputText 
							type="date"
							(input)="dt2.filter($any($event.target).value, 'endDate', 'equals')" 
							[style]="{'width':'100%'}">
					</th>
					<!-- Expense Filters -->
					<th class="filter-input" style="background-color: #e3f2fd;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'expenseAmount', 'contains')" 
							placeholder="Amount" 
							[style]="{'width':'100%'}"> -->
							Amount
					</th>
					<th class="filter-input" style="background-color: #e3f2fd;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'paidByOwner', 'contains')" 
							placeholder="Paid By Owner" 
							[style]="{'width':'100%'}"> -->
							Owner Paid
					</th>
					<th class="filter-input" style="background-color: #e3f2fd;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'paidByKbm', 'contains')" 
							placeholder="Paid By KBM" 
							[style]="{'width':'100%'}"> -->
							KBM Paid
					</th>
					<!-- Statement Expense Filters -->
					<th class="filter-input" style="background-color: #fff3e0;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'stmtExpenseAmount', 'contains')" 
							placeholder="Amount" 
							[style]="{'width':'100%'}"> -->
							Amount
					</th>
					<th class="filter-input" style="background-color: #fff3e0;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'stmtPaidByOwner', 'contains')" 
							placeholder="Paid By Owner" 
							[style]="{'width':'100%'}"> -->
							Owner Paid
					</th>
					<th class="filter-input" style="background-color: #fff3e0;">
						<!-- <input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'stmtPaidByKbm', 'contains')" 
							placeholder="Paid By KBM" 
							[style]="{'width':'100%'}"> -->
							KBM Paid
					</th>
					<th class="filter-input">
						<input 
							pInputText 
							type="text" 
							(input)="dt2.filter($any($event.target).value, 'discrepancyAmount', 'contains')" 
							placeholder="Discrepancy" 
							[style]="{'width':'100%'}">
					</th>
					<th>
						<p-dropdown 
							[filter]="true"
							appendTo="body"
							[options]="matchStatusOptions" 
							dropdownIcon="fa fa-caret-down"
							optionLabel="label" 
							optionValue="value"
							[showClear]="true"
							placeholder="All"
							(onChange)="dt2.filter($event.value, 'expenseMatch', 'equals')"
							[style]="{'width':'100%'}">
						</p-dropdown>
					</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-item>
				<tr style="cursor: pointer;">
					<td><strong>{{item.propertyCode}}</strong></td>
					<td>{{item.startDate | date:'MM-dd-yyyy'}}</td>
					<td>{{item.endDate | date:'MM-dd-yyyy'}}</td>
					
					<!-- Expense Values -->
					<td (click)="openExpenseList(item)" [class.match-success]="isValueMatch(item.expenseAmount, item.stmtExpenseAmount)"
						[class.match-error]="!isValueMatch(item.expenseAmount, item.stmtExpenseAmount)"
						style="background-color: #e3f2fd;">
						{{item.expenseAmount | currency:'USD'}}
					</td>
					<td (click)="openExpenseList(item)" [class.match-success]="isValueMatch(item.paidByOwner, item.stmtPaidByOwner)"
						[class.match-error]="!isValueMatch(item.paidByOwner, item.stmtPaidByOwner)"
						style="background-color: #e3f2fd;">
						{{item.paidByOwner | currency:'USD'}}
					</td>
					<td (click)="openExpenseList(item)" [class.match-success]="isValueMatch(item.paidByKbm, item.stmtPaidByKbm)"
						[class.match-error]="!isValueMatch(item.paidByKbm, item.stmtPaidByKbm)"
						style="background-color: #e3f2fd;">
						{{item.paidByKbm | currency:'USD'}}
					</td>
					
					<!-- Statement Expense Values -->
					<td (click)="openExpenseList(item,true)" [class.match-success]="isValueMatch(item.expenseAmount, item.stmtExpenseAmount)"
						[class.match-error]="!isValueMatch(item.expenseAmount, item.stmtExpenseAmount)"
						style="background-color: #fff3e0;">
						{{item.stmtExpenseAmount | currency:'USD'}}
					</td>
					<td (click)="openExpenseList(item,true)" [class.match-success]="isValueMatch(item.paidByOwner, item.stmtPaidByOwner)"
						[class.match-error]="!isValueMatch(item.paidByOwner, item.stmtPaidByOwner)"
						style="background-color: #fff3e0;">
						{{item.stmtPaidByOwner | currency:'USD'}}
					</td>
					<td (click)="openExpenseList(item,true)" [class.match-success]="isValueMatch(item.paidByKbm, item.stmtPaidByKbm)"
						[class.match-error]="!isValueMatch(item.paidByKbm, item.stmtPaidByKbm)"
						style="background-color: #fff3e0;">
						{{item.stmtPaidByKbm | currency:'USD'}}
					</td>
					
					<!-- Discrepancy -->
					<td [ngClass]="getDiscrepancyClass(item.discrepancyAmount)">
						<strong>{{item.discrepancyAmount | currency:'USD'}}</strong>
					</td>
					
					<!-- Match Status -->
					<td [ngClass]="getMatchStatusClass(item.expenseMatch)">
						<i class="pi" [ngClass]="getMatchStatusIcon(item.expenseMatch)"></i>
						<span style="margin-left: 8px;">{{getMatchStatusText(item.expenseMatch)}}</span>
					</td>

					<td>
						<span class="link fw-bold blink-text" (click)="openStatementRez(item)">
							View Rez
						</span>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
